// extracted by mini-css-extract-plugin
export default {"mainView":"CategoryReorder_mainView__1vGPG"};